document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.store-search-form').forEach(form => {
    const field = form.querySelector('input[type="search"]');
    const clear = form.querySelector('.search-clear');
    if (!field || !clear) return;
    const updateClear = () => { clear.hidden = !field.value; };
    field.addEventListener('input', updateClear);
    clear.addEventListener('click', () => {
      field.value = '';
      field.dispatchEvent(new Event('input', {bubbles: true}));
      field.focus();
    });
    updateClear();
  });
  const dialog = document.querySelector('#store-search');
  const toggle = document.querySelector('.header-search-toggle');
  if (!dialog || !toggle || typeof dialog.showModal !== 'function') return;
  const input = dialog.querySelector('input[type="search"]');
  const results = dialog.querySelector('#store-search-results');
  const status = dialog.querySelector('[data-search-status]');
  let timer, controller;
  toggle.addEventListener('click', event => {
    event.preventDefault();
    dialog.showModal();
    toggle.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('store-search-open');
    input.focus();
  });
  dialog.querySelector('[data-search-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    clearTimeout(timer);
    controller?.abort();
    status.textContent = '';
    toggle.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('store-search-open');
    toggle.focus();
  });
  input.addEventListener('input', () => {
    clearTimeout(timer);
    controller?.abort();
    results.replaceChildren();
    status.textContent = '';
    const query = input.value.trim();
    if (query.length < 2) return;
    timer = setTimeout(async () => {
      controller = new AbortController();
      status.textContent = 'Searching…';
      const url = new URL(dialog.querySelector('form').action);
      url.pathname = url.pathname.replace(/\/$/, '') + '/suggest';
      url.search = new URLSearchParams({q: query, section_id: 'predictive-search', 'resources[type]': 'product,collection,article,page', 'resources[limit]': '8', 'resources[limit_scope]': 'all', 'resources[options][fields]': 'title,product_type,variants.title,vendor,variants.sku,body'});
      try {
        const response = await fetch(url, {signal: controller.signal});
        if (!response.ok) throw new Error('Search unavailable');
        const html = await response.text();
        if (input.value.trim() !== query || !dialog.open) return;
        const documentResult = new DOMParser().parseFromString(html, 'text/html');
        const section = documentResult.querySelector('#shopify-section-predictive-search');
        if (!section) throw new Error('Search results unavailable');
        results.replaceChildren(...section.childNodes);
        status.textContent = 'Search suggestions updated.';
      } catch (error) {
        if (error.name === 'AbortError') return;
        status.textContent = 'Press Search to see all matching results.';
      }
    }, 250);
  });
});
